import { Incarico } from './incarico';
import { Model } from './model';
import { Provincia } from './provincia';

export class Comune extends Model {
  static apiUrl: string = "comuni";

  nome: string;

  provincia: Provincia;
  incarichi: Incarico[];

  provincia_id: number;

  cap: string;

  deserialize(input: any): Comune {
    let retV: Comune = new Comune();
    retV = super.deserialize(input) as Comune;

    if (input?.provincia) {
      retV.provincia = new Provincia().deserialize(input.provincia);
    }

    if (input?.incarichi) {
      retV.incarichi = input.incarichi.map(m => new Incarico().deserialize(m));
    }


    return retV;
  }

}
